module.exports = __webpack_public_path__ + "static/media/report.8f9a28c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/ssp2/report.svg
// module id = 496
// module chunks = 0